import React, { useState, useRef, useEffect, useMemo } from "react";
import { handleDownloadEditablePPT } from "./PptHelper";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import KeyboardArrowDown from "@mui/icons-material/KeyboardArrowDown";
import Tooltip from "@mui/material/Tooltip";
import Swal from "sweetalert2";
import axios from "axios";
import { CircularProgress, Snackbar, Alert } from "@mui/material";
import { Skeleton } from "@mui/material";
import ClientRecceApprovalModal from "../RFPDashboard/RecceApproval/ClientRecceApprovalModal.js";
import ClientRecceRejectedModal from "../RFPDashboard/RecceApproval/ClientRecceRejectedModal.js";
import InstallationFlag from "./InstallationFlag.jsx";
const templates = [
  {
    id: 1,
    layoutType: "recce-ppt",
    templateName: "Recce PPT",
    bgColor: "bg-blue-50",
  },

  {
    id: 2,
    layoutType: "creative-ppt",
    templateName: "Creative PPT",
    bgColor: "bg-yellow-50",
  },

  {
    id: 3,
    layoutType: "completion-ppt",
    templateName: "Completion PPT",
    bgColor: "bg-gray-50",
  },
];

const getProductFromRecce = (recce) => {
  const directProduct = recce?.product || {};
  const jobProduct = recce?.job?.product || {};
  const rfpProducts = recce?.campaignId?.rfpId?.products || [];

  const targetType =
    directProduct?.productType || jobProduct?.productType || null;

  let matchedProduct = {};

  if (targetType) {
    matchedProduct =
      rfpProducts.find((p) => p.productType === targetType) || {};
  }

  return {
    ...matchedProduct,
    ...jobProduct,
    ...directProduct,
  };
};

export default function TemplateModal({
  isOpen,
  onClose,
  recceData,
  isPreviewCompletionReport,
  role,
  handleCreativeOpen,
  refreshCreative,
  onRecceStatusChanged,
  getApprovalList,
}) {
  const userId = localStorage.getItem("userId");
  const clientId = localStorage.getItem("clientId");
  const [isLoading, setIsLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [downloadInfo, setDownloadInfo] = useState(null);

  // creative status

  const [creativeComments, setCreativeComments] = useState({});
  const [activeCommentBox, setActiveCommentBox] = useState(null);
  const [selectedCommentIndex, setSelectedCommentIndex] = useState(null);
  const [approvalData, setApprovalData] = useState({});
  const [approvedLoading, setIsApprovedLoading] = useState(false);
  const [rejectLoading, setIsRejectLoading] = useState(false);
  const [templateModalLoading, setTemplateModalLoading] = useState(false);
  const userRole = localStorage.getItem("role");

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const [dimensionEdits, setDimensionEdits] = useState({});
  const [localClientStatus, setLocalClientStatus] = useState({});
  const [recceApproveLoadingId, setRecceApproveLoadingId] = useState(null);
  const [recceRejectLoadingId, setRecceRejectLoadingId] = useState(null);
  const [approvedDimensions, setApprovedDimensions] = useState({});
  const [approvalModalOpen, setApprovalModalOpen] = useState(false);
  const [rejectModalOpen, setRejectModalOpen] = useState(false);
  const [pendingRecceData, setPendingRecceData] = useState(null);
  const [flagStatuses, setFlagStatuses] = useState({});

  const newrecceData = recceData.filter((s) => {
    if (s.adminStatus == 1) {
      return s;
    }
  });
  const [currentIndex, setCurrentIndex] = useState(0);
  const modalRef = useRef(null);

  const updatedRecceData = newrecceData
    .filter((job) => job.clientStatus !== 2)
    .map((item) => {
      const { storeName, address, city, state } = item.job;

      const fullAddress = `${storeName}, ${address}, ${city}, ${state}`;
      const mapLink = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
        fullAddress,
      )}`;

      return {
        ...item,
        job: {
          ...item.job,
          location: mapLink, // ✅ new field added
        },
      };
    });

  const [selectedId, setSelectedId] = useState(null);
  const selectedTemplate = templates.find((tpl) => tpl?.id === selectedId);
  const [completionDownloadScope, setCompletionDownloadScope] = useState("all");
  const GEO_OPTIONS = [
    { value: "with", label: "With geo tag" },
    { value: "without", label: "Without geo tag" },
  ];
  const [geoTag, setGeoTag] = useState("with"); // "with" | "without"
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  const mergedRecceData = useMemo(() => {
    const shouldRemoveRejected =
      selectedTemplate?.layoutType === "creative-ppt" ||
      selectedTemplate?.layoutType === "completion-ppt";

    return updatedRecceData
      .filter((job) => !shouldRemoveRejected || job.clientStatus !== -1)
      .map((item) => {
        const id = item?._id;
        const jId = item?.job?._id || item?.job?.jobId;

        const statusOverride = localClientStatus[id];
        const dimsOverride = approvedDimensions[id];
        const creativeStatusOverride = approvalData[jId]?.clientCreativeStatus;

        return {
          ...item,

          clientStatus:
            statusOverride !== undefined ? statusOverride : item.clientStatus,

          job: {
            ...item.job,
            clientCreativeStatus:
              creativeStatusOverride !== undefined
                ? creativeStatusOverride
                : item?.job?.clientCreativeStatus,
          },

          product: {
            ...item.product,
            approvedWidth:
              dimsOverride?.approvedWidth ?? item?.product?.approvedWidth,

            approvedHeight:
              dimsOverride?.approvedHeight ?? item?.product?.approvedHeight,
          },
        };
      });
  }, [
    updatedRecceData,
    selectedTemplate,
    localClientStatus,
    approvedDimensions,
    approvalData,
  ]);

  const hasInstallationImage = (recce) =>
    Boolean(recce?.installationJob?.imagesOfInstallation?.frontPhoto);

  const previewRecceData = useMemo(() => {
    const isCompletionInstalledOnly =
      selectedTemplate?.layoutType === "completion-ppt" &&
      completionDownloadScope === "installedOnly";

    if (!isCompletionInstalledOnly) return mergedRecceData;

    return mergedRecceData.filter((recce) => hasInstallationImage(recce));
  }, [mergedRecceData, selectedTemplate, completionDownloadScope]);

  // Revoke the previous blob URL whenever a new one is created, and on unmount,
  // so we don't leak memory by holding onto stale object URLs.
  useEffect(() => {
    return () => {
      if (downloadInfo?.url) {
        URL.revokeObjectURL(downloadInfo.url);
      }
    };
  }, [downloadInfo]);

  // If the user picks a different template, the previously generated file no
  // longer matches what's selected — clear it so they don't download the wrong one.
  useEffect(() => {
    setDownloadInfo((prev) => {
      if (prev?.url) URL.revokeObjectURL(prev.url);
      return null;
    });
    setCompletionDownloadScope("all");
  }, [selectedId]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  useEffect(() => {
    setDownloadInfo((prev) => {
      if (prev?.url) URL.revokeObjectURL(prev.url);
      return null;
    });
  }, [geoTag]);
  const showSnackbar = (message, severity = "success") => {
    setSnackbar({
      open: true,
      message,
      severity,
    });
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbar({
      ...snackbar,
      open: false,
    });
  };

  const handleImageClick = (e, jobId) => {
    const rect = e.currentTarget.getBoundingClientRect();

    const xPercent = ((e.clientX - rect.left) / rect.width) * 100;
    const yPercent = ((e.clientY - rect.top) / rect.height) * 100;

    const existing = creativeComments[jobId] || [];

    if (existing.length >= 5) {
      Swal.fire({
        customClass: {
          container: "my-swal",
        },
        icon: "warning",
        title: "Limit Reached",
        text: "Maximum 5 comments allowed per creative.",
        confirmButtonColor: "#3085d6",
      });
      return;
    }

    setActiveCommentBox({
      jobId,
      x: xPercent,
      y: yPercent,
      text: "",
    });
  };
  const currentRecce = previewRecceData[currentIndex];
  const jobId = currentRecce?.job?._id || currentRecce?.job?.jobId;

  const fetchedJobIdsRef = useRef(new Set());
  useEffect(() => {
    if (jobId && selectedTemplate?.layoutType === "creative-ppt") {
      if (!fetchedJobIdsRef.current.has(jobId)) {
        fetchedJobIdsRef.current.add(jobId);
        fetchApproval(jobId);
      }
    }
  }, [jobId, selectedTemplate?.layoutType]);

  useEffect(() => {
    setCurrentIndex(0);
  }, [selectedTemplate?.layoutType]);

  useEffect(() => {
    setCurrentIndex(0);
  }, [completionDownloadScope]);

  useEffect(() => {
    if (
      jobId &&
      selectedTemplate?.layoutType === "creative-ppt" &&
      refreshCreative
    ) {
      fetchApproval(jobId);
    }
  }, [refreshCreative]);

  const handleDownload = () => {
    if (!selectedId) {
      Swal.fire({
        customClass: {
          container: "my-swal",
        },
        icon: "warning",
        title: "No Template Selected",
        text: "Please select a template to download.",
        confirmButtonColor: "#3085d6",
      });
      return;
    }

    const isCompletionInstalledOnly =
      selectedTemplate.layoutType === "completion-ppt" &&
      completionDownloadScope === "installedOnly";

    const dataToExport = isCompletionInstalledOnly
      ? mergedRecceData.filter(hasInstallationImage)
      : mergedRecceData;

    if (isCompletionInstalledOnly && dataToExport.length === 0) {
      Swal.fire({
        customClass: {
          container: "my-swal",
        },
        icon: "warning",
        title: "No Matching Slides",
        text: "None of the stores currently have an installation image. Try 'All Slides' instead.",
        confirmButtonColor: "#3085d6",
      });
      return;
    }

    handleDownloadEditablePPT(
      dataToExport,
      selectedTemplate.layoutType,
      setIsLoading,
      setProgress,
      setDownloadInfo,
      selectedTemplate.layoutType === "completion-ppt"
        ? { geoTag: geoTag === "with" }
        : undefined,
    );
  };

  const fetchApproval = async (jobId) => {
    setTemplateModalLoading(true);
    try {
      const token = localStorage.getItem("token");

      const res = await axios.get(
        `${process.env.REACT_APP_URL}/creativeApprovals/viewCreativeApproval/${jobId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = res.data.data;

      setApprovalData((prev) => ({
        ...prev,
        [jobId]: data || { comments: [], clientCreativeStatus: 0 },
      }));

      // 🔥 IMPORTANT: comments bhi set karo
      setCreativeComments((prev) => ({
        ...prev,
        [jobId]: data?.comments || [],
      }));
    } catch (err) {
      console.log(err);
    } finally {
      setTemplateModalLoading(false);
    }
  };

  // Effective status = optimistic local override
  const getEffectiveClientStatus = (recce) => {
    const id = recce?._id;
    return localClientStatus[id] ?? recce?.clientStatus;
  };

  const handleDimensionInputChange = (id, field, value) => {
    if (value !== "" && !/^\d*\.?\d*$/.test(value)) return;
    setDimensionEdits((prev) => ({
      ...prev,
      [id]: {
        ...prev[id],
        [field]: value,
      },
    }));
  };

  // Helper function to get dimensions
  const getDimensions = (recce, id) => {
    const width =
      dimensionEdits[id]?.width !== undefined
        ? dimensionEdits[id]?.width
        : recce?.product?.approvedWidth ||
          recce?.job?.productDimensionsAfterRecce?.width ||
          "";

    const height =
      dimensionEdits[id]?.height !== undefined
        ? dimensionEdits[id]?.height
        : recce?.product?.approvedHeight ||
          recce?.job?.productDimensionsAfterRecce?.height ||
          "";

    return { width, height };
  };

  const handleApproveRecceClick = (recce) => {
    const id = recce?._id;
    const { width, height } = getDimensions(recce, id);

    if (!width || !height) {
      showSnackbar(
        "Please enter both width and height before approving.",
        "warning",
      );
      return;
    }

    const actualWidth = recce?.job?.productDimensionsAfterRecce?.width;
    const actualHeight = recce?.job?.productDimensionsAfterRecce?.height;

    if (actualWidth && Number(width) > actualWidth) {
      showSnackbar(
        `Width (${Number(width)} ft) cannot exceed the actual width (${actualWidth} ft). Please enter a valid width.`,
        "warning",
      );
      return;
    }

    if (actualHeight && Number(height) > actualHeight) {
      showSnackbar(
        `Height (${Number(height)} ft) cannot exceed the actual height (${actualHeight} ft). Please enter a valid height.`,
        "warning",
      );
      return;
    }

    setPendingRecceData(recce);
    setApprovalModalOpen(true);
  };

  const handleRejectRecceClick = (recce) => {
    setPendingRecceData(recce);
    setRejectModalOpen(true);
  };

  const handleApproveRecce = async (recce, comment) => {
    const id = recce?._id;
    const productId = recce?.product?._id;
    const { width, height } = getDimensions(recce, id);

    setRecceApproveLoadingId(id);
    try {
      const token = localStorage.getItem("token");

      if (productId) {
        await axios.put(
          `${process.env.REACT_APP_URL}/product/updateProduct/${productId}`,
          {
            approvedWidth: Number(width),
            approvedHeight: Number(height),
            role,
          },
          { headers: { Authorization: `Bearer ${token}` } },
        );
      }

      await axios.put(
        `${process.env.REACT_APP_URL}/installationPartnerJobApproval/updateApprovalStatus/${id}`,
        {
          clientId: localStorage.getItem("clientId"),
          clientStatus: 1,
          clientApprovalReason: comment || "Approved from PPT view",
        },
        { headers: { Authorization: `Bearer ${token}` } },
      );

      setLocalClientStatus((prev) => ({ ...prev, [id]: 1 }));

      setApprovedDimensions((prev) => ({
        ...prev,
        [id]: {
          approvedWidth: Number(width),
          approvedHeight: Number(height),
        },
      }));

      setDimensionEdits((prev) => {
        const newState = { ...prev };
        delete newState[id];
        return newState;
      });

      showSnackbar("Approved successfully!", "success");
    } catch (err) {
      console.error("Approval error:", err);
      showSnackbar("Failed to approve. Please try again.", "error");
    } finally {
      setRecceApproveLoadingId(null);
      setApprovalModalOpen(false);
      setPendingRecceData(null);
      onRecceStatusChanged?.();
    }
  };

  const handleRejectRecce = async (recce, comment) => {
    const id = recce?._id;

    setRecceRejectLoadingId(id);
    try {
      const token = localStorage.getItem("token");

      await axios.put(
        `${process.env.REACT_APP_URL}/installationPartnerJobApproval/updateApprovalStatus/${id}`,
        {
          clientId: localStorage.getItem("clientId"),
          clientStatus: -1,
          clientrejectionReason: comment || "Rejected from PPT view",
        },
        { headers: { Authorization: `Bearer ${token}` } },
      );

      setLocalClientStatus((prev) => ({ ...prev, [id]: -1 }));

      setDimensionEdits((prev) => {
        const newState = { ...prev };
        delete newState[id];
        return newState;
      });

      showSnackbar("Rejected successfully!", "success");
    } catch (err) {
      console.log(err);
      showSnackbar("Failed to reject. Please try again.", "error");
    } finally {
      setRecceRejectLoadingId(null);
      setRejectModalOpen(false);
      setPendingRecceData(null);
      onRecceStatusChanged?.();
    }
  };

  const handleApprovalSubmit = (comment) => {
    if (pendingRecceData) {
      handleApproveRecce(pendingRecceData, comment);
    }
  };

  const handleRejectSubmit = (comment) => {
    if (pendingRecceData) {
      handleRejectRecce(pendingRecceData, comment);
    }
  };

  const renderTemplateThumbnail = (tpl) => {
    const isSelected = selectedId === tpl?.id;
    const hasGeoOption = tpl?.layoutType === "completion-ppt";

    // Recce / Creative: identical to your original
    if (!hasGeoOption) {
      return (
        <div
          key={tpl?.id}
          onClick={() => {
            setSelectedId(tpl?.id);
          }}
          className={`
          min-w-[80px] sm:min-w-[110px] lg:min-w-[130px] text-xs sm:text-sm p-2 sm:p-3
          rounded-lg shadow-md transition-all duration-200 mx-2
          ${tpl?.bgColor}
          ${isSelected ? "ring-2 ring-blue-500" : ""}
          ${"cursor-pointer hover:scale-105"}`}
        >
          <p>{tpl?.templateName}</p>
        </div>
      );
    }

    // Completion PPT: split button with dropdown
    return (
      <div key={tpl?.id} ref={menuRef} className="relative mx-2">
        <div
          className={`
          flex items-stretch overflow-hidden rounded-lg shadow-md transition-all duration-200
          ${tpl?.bgColor}
          ${isSelected ? "ring-2 ring-blue-500" : ""}`}
        >
          <button
            type="button"
            onClick={() => setSelectedId(tpl?.id)}
            className="min-w-[80px] sm:min-w-[110px] lg:min-w-[130px] p-2 sm:p-3 text-left text-xs sm:text-sm"
          >
            {tpl?.templateName}
          </button>

          <button
            type="button"
            aria-haspopup="listbox"
            aria-expanded={menuOpen}
            disabled={isLoading}
            onClick={() => {
              setSelectedId(tpl?.id);
              setMenuOpen((prev) => !prev);
            }}
            className="flex items-center border-l border-black/10 px-1.5 hover:bg-black/5 disabled:cursor-not-allowed disabled:opacity-50"
          >
            <KeyboardArrowDown
              sx={{ fontSize: 18 }}
              className={`transition-transform duration-200 ${menuOpen ? "rotate-180" : ""}`}
            />
          </button>
        </div>

        {menuOpen && (
          <ul
            role="listbox"
            className="absolute left-0 z-[60] mt-1 w-44 rounded-md border border-gray-200 bg-white py-1 shadow-lg"
          >
            {GEO_OPTIONS.map((opt) => (
              <li
                key={opt.value}
                role="option"
                aria-selected={geoTag === opt.value}
                onClick={() => {
                  setGeoTag(opt.value);
                  setMenuOpen(false);
                }}
                className={`flex cursor-pointer items-center justify-between px-3 py-2 text-xs sm:text-sm hover:bg-gray-100 ${
                  geoTag === opt.value
                    ? "font-semibold text-blue-600"
                    : "text-gray-700"
                }`}
              >
                {opt.label}
                {geoTag === opt.value && <span>✓</span>}
              </li>
            ))}
          </ul>
        )}
      </div>
    );
  };

  const renderTemplateCard = (recce, template, isPreview = false) => {
    const { layoutType, bgColor } = template;

    const selectedRing =
      !isPreview && selectedId === recce.id ? "ring-2 ring-blue-500" : "";
    const currentRecce = previewRecceData[currentIndex];

    const jobId = currentRecce?.job?._id || currentRecce?.job?.jobId;

    const getStatusLabel = (status) => {
      if (status === 1) return "Approved";
      if (status === -1) return "Rejected";
      return "Pending";
    };
    const currentStatus = getStatusLabel(
      approvalData[jobId]?.clientCreativeStatus,
    );

    const comments = creativeComments[jobId] || [];

    const product = getProductFromRecce(recce);

    const availableWidth =
      recce?.job?.productDimensionsAfterRecce?.width > 0
        ? recce.job.productDimensionsAfterRecce.width
        : null;

    const availableHeight =
      recce?.job?.productDimensionsAfterRecce?.height > 0
        ? recce.job.productDimensionsAfterRecce.height
        : null;

    const approvalId = recce?._id;
    const approvedWidth =
      approvedDimensions[approvalId]?.approvedWidth ??
      recce?.product?.approvedWidth ??
      null;

    const approvedHeight =
      approvedDimensions[approvalId]?.approvedHeight ??
      recce?.product?.approvedHeight ??
      null;

    const handleApprove = async (jobId) => {
      setApprovalData((prev) => ({
        ...prev,
        [jobId]: {
          ...prev[jobId],
          clientCreativeStatus: 1,
        },
      }));
      setIsApprovedLoading(true);
      try {
        const token = localStorage.getItem("token");

        await axios.patch(
          `${process.env.REACT_APP_URL}/creativeApprovals/editCreativeApproval`,
          {
            clientCreativeStatus: 1,
          },
          {
            params: { jobId, clientId, userId },
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        showSnackbar("Creative approved successfully!", "success");
      } catch (err) {
        setApprovalData((prev) => ({
          ...prev,
          [jobId]: {
            ...prev[jobId],
            clientCreativeStatus: prev[jobId]?.clientCreativeStatus || 0,
          },
        }));
        showSnackbar("Failed to approve. Please try again.", "error");
      } finally {
        setIsApprovedLoading(false);
      }
    };

    const handleReject = async (jobId) => {
      //  OPTIMISTIC UPDATE
      setApprovalData((prev) => ({
        ...prev,
        [jobId]: {
          ...prev[jobId],
          clientCreativeStatus: -1,
        },
      }));
      setIsRejectLoading(true);
      try {
        const token = localStorage.getItem("token");

        await axios.patch(
          `${process.env.REACT_APP_URL}/creativeApprovals/editCreativeApproval`,
          {
            clientCreativeStatus: -1,
          },
          {
            params: { jobId, clientId },
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        showSnackbar("Creative rejected successfully!", "success");
      } catch (err) {
        setApprovalData((prev) => ({
          ...prev,
          [jobId]: {
            ...prev[jobId],
            clientCreativeStatus: prev[jobId]?.clientCreativeStatus || 0,
          },
        }));
        showSnackbar("Failed to reject. Please try again.", "error");
      } finally {
        setIsRejectLoading(false);
      }
    };

    const saveComment = async (jobId) => {
      if (!activeCommentBox?.text?.trim()) return;

      const newComment = {
        text: activeCommentBox.text,
        coordinates: {
          x: activeCommentBox.x,
          y: activeCommentBox.y,
        },
        commentedBy: localStorage.getItem("clientId"),
      };

      const existing = creativeComments[jobId] || [];

      let updatedComments;

      // 🔥 EDIT CASE
      if (selectedCommentIndex !== null) {
        updatedComments = existing.map((c, i) =>
          i === selectedCommentIndex
            ? {
                ...c,
                text: newComment.text,
                coordinates: newComment.coordinates,
              }
            : c,
        );
      }
      // 🔥 ADD CASE
      else {
        if (existing.length >= 5) {
          Swal.fire("Max 5 comments allowed");
          return;
        }
        updatedComments = [...existing, newComment];
      }

      setCreativeComments((prev) => ({
        ...prev,
        [jobId]: updatedComments,
      }));

      try {
        const token = localStorage.getItem("token");

        await axios.patch(
          `${process.env.REACT_APP_URL}/creativeApprovals/editCreativeApproval`,
          {
            comments: updatedComments,
            commentedBy: localStorage.getItem("name"),
          },
          {
            params: { jobId, clientId },
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        showSnackbar("Comment saved successfully!", "success");
        setActiveCommentBox(null);
        setSelectedCommentIndex(null);
      } catch (err) {
        setCreativeComments((prev) => ({
          ...prev,
          [jobId]: existing,
        }));
        showSnackbar("Failed to save comment. Please try again.", "error");
      }
    };

    const deleteComment = async () => {
      if (selectedCommentIndex === null) return;

      const jobId = activeCommentBox.jobId;
      const existing = creativeComments[jobId] || [];

      const updated = existing.filter((_, i) => i !== selectedCommentIndex);

      setCreativeComments((prev) => ({
        ...prev,
        [jobId]: updated,
      }));

      try {
        const token = localStorage.getItem("token");

        await axios.patch(
          `${process.env.REACT_APP_URL}/creativeApprovals/editCreativeApproval`,
          {
            comments: updated,
          },
          {
            params: { jobId, clientId },
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        showSnackbar("Comment deleted successfully!", "success");
        setActiveCommentBox(null);
        setSelectedCommentIndex(null);
      } catch (err) {
        setCreativeComments((prev) => ({
          ...prev,
          [jobId]: existing,
        }));
        showSnackbar("Failed to delete comment. Please try again.", "error");
      }
    };

    const effectiveStatus = getEffectiveClientStatus(recce);
    const isRecceApproved = effectiveStatus === 1;
    const isRecceRejected = effectiveStatus === -1;
    const isRecceHold = effectiveStatus === 2;
    const actionsLocked = isRecceApproved || isRecceRejected;

    const widthValue =
      dimensionEdits[approvalId]?.width !== undefined
        ? dimensionEdits[approvalId]?.width
        : (approvedWidth ?? availableWidth ?? "");

    const heightValue =
      dimensionEdits[approvalId]?.height !== undefined
        ? dimensionEdits[approvalId]?.height
        : (approvedHeight ?? availableHeight ?? "");

    switch (layoutType) {
      case "recce-ppt":
        return (
          <div
            key={recce?.storeName + Math.random()}
            className={`shadow-xl bg-gray-100 flex flex-col ${selectedRing}`}
            style={
              isPreview ? { maxHeight: "70%", border: "1px solid black" } : {}
            }
          >
            <div className="flex justify-between items-center p-3 sm:p-4 flex-wrap gap-2">
              <div className="flex items-center gap-2"></div>
              <div className="flex items-center gap-2 flex-wrap">
                {role === "client" && (
                  <>
                    <div className="flex items-center gap-2">
                      <label className="text-xs font-medium text-gray-600">
                        Width (ft)
                      </label>
                      <input
                        type="text"
                        inputMode="decimal"
                        value={widthValue}
                        disabled={actionsLocked}
                        placeholder="Width"
                        onChange={(e) =>
                          handleDimensionInputChange(
                            approvalId,
                            "width",
                            e.target.value,
                          )
                        }
                        className="w-20 border rounded px-2 py-1 text-sm disabled:bg-gray-100 disabled:text-gray-500"
                      />
                    </div>

                    <div className="flex items-center gap-2">
                      <label className="text-xs font-medium text-gray-600">
                        Height (ft)
                      </label>
                      <input
                        type="text"
                        inputMode="decimal"
                        value={heightValue}
                        disabled={actionsLocked}
                        placeholder="Height"
                        onChange={(e) =>
                          handleDimensionInputChange(
                            approvalId,
                            "height",
                            e.target.value,
                          )
                        }
                        className="w-20 border rounded px-2 py-1 text-sm disabled:bg-gray-100 disabled:text-gray-500"
                      />
                    </div>
                  </>
                )}

                {/* ADMIN STATUS CHIP - ONLY IN DOWNLOAD and NOT IN VIEW */}
                {!isPreview &&
                  role === "admin" &&
                  recce?.adminStatus !== undefined &&
                  recce?.adminStatus !== 0 && (
                    <div className="font-semibold flex justify-center items-center text-xs sm:text-sm mx-2 sm:mx-4">
                      {`Admin Status:`}
                      <span
                        className={`
            ml-2 px-3 py-1 rounded-full text-white
                  ${recce?.adminStatus === 1 ? "bg-green-400" : "bg-red-400"}
                `}
                      >
                        {recce?.adminStatus === 1 ? "Approved" : "Rejected"}
                      </span>
                    </div>
                  )}

                {/* CLIENT STATUS CHIP - Admin sees all statuses */}
                {role === "admin" && (
                  <div className="font-semibold flex justify-center items-center text-xs sm:text-sm mx-2 sm:mx-4">
                    {`Client Approval:`}
                    <span
                      className={`
                  ml-2 px-3 py-1 rounded-full text-white
                  ${isRecceApproved ? "bg-green-400" : isRecceRejected ? "bg-red-400" : "bg-yellow-400"}
                `}
                    >
                      {isRecceApproved
                        ? "Approved"
                        : isRecceRejected
                          ? "Rejected"
                          : "Pending"}
                    </span>
                  </div>
                )}

                {/* CLIENT STATUS CHIP - Client sees only Approved/Rejected */}
                {role === "client" && (isRecceApproved || isRecceRejected) && (
                  <div className="font-semibold flex justify-center items-center text-xs sm:text-sm mx-2 sm:mx-4">
                    {`Client Approval:`}
                    <span
                      className={`
                  ml-2 px-3 py-1 rounded-full text-white
                  ${isRecceApproved ? "bg-green-400" : "bg-red-400"}
                `}
                    >
                      {isRecceApproved ? "Approved" : "Rejected"}
                    </span>
                  </div>
                )}

                {/* Approve / Reject Buttons - ONLY FOR CLIENT */}
                {role === "client" && !actionsLocked && (
                  <div className="flex items-center gap-2 mr-2 sm:mr-3">
                    {(() => {
                      const isLoading =
                        recceApproveLoadingId === recce?._id ||
                        recceRejectLoadingId === recce?._id;
                      return (
                        <>
                          <button
                            onClick={() => handleApproveRecceClick(recce)}
                            disabled={isLoading}
                            className={`
                        min-w-[90px]
                        h-[35px]
                        flex items-center justify-center
                        rounded-lg
                        bg-green-400
                        text-white
                        font-medium
                        shadow-md
                        transition-all duration-200
                        hover:bg-green-500 hover:shadow-lg
                        active:scale-95
                        disabled:bg-gray-300
                        disabled:cursor-not-allowed
                        whitespace-nowrap
                      `}
                          >
                            {recceApproveLoadingId === recce?._id ? (
                              <div className="flex items-center gap-2">
                                <CircularProgress size={16} />
                                <span>Approving</span>
                              </div>
                            ) : (
                              "Approve"
                            )}
                          </button>

                          <button
                            onClick={() => handleRejectRecceClick(recce)}
                            disabled={isLoading}
                            className={`
                        min-w-[90px]
                        h-[35px]
                        flex items-center justify-center
                        rounded-lg
                        bg-red-400
                        text-white
                        font-medium
                        shadow-md
                        transition-all duration-200
                        hover:bg-red-500 hover:shadow-lg
                        active:scale-95
                        disabled:bg-gray-300
                        disabled:cursor-not-allowed
                        whitespace-nowrap
                      `}
                          >
                            {recceRejectLoadingId === recce?._id ? (
                              <div className="flex items-center gap-2">
                                <CircularProgress size={16} />
                                <span>Rejecting</span>
                              </div>
                            ) : (
                              "Reject"
                            )}
                          </button>
                        </>
                      );
                    })()}
                  </div>
                )}

                {/* Logo on the RIGHT */}
                <img
                  src="/assests/images/pixell dark.png"
                  alt="Pixell Logo"
                  className="w-24 h-auto"
                />
              </div>
            </div>

            <div className="flex flex-col lg:flex-row gap-4 lg:gap-6 px-4 lg:px-6 pb-6">
              <div className="w-full lg:w-[65%] rounded-xl shadow-md p-4 bg-white border">
                <div className="flex items-center mb-2 ml-4 mt-4">
                  <h2 className="text-lg font-semibold ">Product Name: </h2>
                  <h2 className="text-lg ml-2">
                    {recce?.product?.productType || "N/A"}
                  </h2>
                </div>

                <div>
                  {recce?.job?.imageOfRecceSpace ? (
                    <img
                      src={recce.job.imageOfRecceSpace}
                      alt="Recce"
                      className="w-full h-[260px] sm:h-[320px] lg:h-[390px] object-contain"
                    />
                  ) : (
                    <div className="w-full h-[320px] flex items-center justify-center text-gray-500">
                      Recce photo not available
                    </div>
                  )}
                </div>
              </div>

              <div className="w-full lg:w-[35%] flex flex-col gap-4">
                <div className="bg-white rounded-xl shadow-md p-4 border">
                  <h3 className="font-semibold text-gray-800 mb-3">
                    Store Details
                  </h3>
                  <div className="space-y-2 text-sm text-gray-700">
                    <p> Store : {recce?.job?.storeName || "N/A"}</p>
                    <p>Name : {recce?.job?.storeOwnerName || "N/A"}</p>
                    <p>Phone : {recce?.job?.storeOwnerPhoneNumber || "N/A"}</p>
                    <p className="flex items-start gap-2">
                      Address : {recce?.job?.address || "N/A"}
                    </p>
                  </div>
                </div>

                <div className="bg-white rounded-xl shadow-md p-4 border">
                  <h3 className="font-semibold text-gray-800 mb-3">
                    Measurement Details
                  </h3>
                  <div className="space-y-2 text-sm text-gray-700">
                    <p>
                      Dimensions (W x H):{" "}
                      {availableWidth && availableHeight
                        ? `${Math.round(availableWidth * 12)}" × ${Math.round(availableHeight * 12)}"`
                        : "N/A"}
                    </p>

                    <p>
                      Area:{" "}
                      {availableWidth && availableHeight
                        ? `${Math.ceil(availableWidth * availableHeight).toFixed(2)} sq.ft.`
                        : "N/A"}
                    </p>

                    <p className="font-semibold text-gray-700 ">
                      Approved Dimensions (W x H):{" "}
                      {approvedWidth && approvedHeight
                        ? `${Math.round(approvedWidth * 12)}" × ${Math.round(approvedHeight * 12)}"`
                        : "N/A"}
                    </p>

                    <p className="font-semibold text-gray-700 ">
                      Approved Area:{" "}
                      {approvedWidth && approvedHeight
                        ? `${Math.ceil(approvedWidth * approvedHeight).toFixed(2)} sq.ft.`
                        : "N/A"}
                    </p>
                  </div>
                </div>

                <div className="bg-white rounded-xl shadow-md p-4 border">
                  <h3 className="font-semibold text-gray-800 mb-3">
                    Additional Details
                  </h3>
                  <div className="space-y-2 text-sm text-gray-700">
                    <p>
                      Mounting Base Type :{" "}
                      {recce?.job?.typeOfMountingBase || "N/A"}
                    </p>
                    <p>
                      External Equipments :{" "}
                      {recce?.job?.externalEquipments?.length
                        ? recce.job.externalEquipments.join(", ")
                        : "N/A"}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="w-full h-4 bg-gradient-to-r from-pink-200 via-purple-200 to-blue-300"></div>
          </div>
        );

      case "creative-ppt":
        return (
          <>
            {templateModalLoading ? (
              <div className="h-[600px] border  border-gray-200 rounded-xl p-5 bg-white">
                {/* Header */}
                <div className="flex items-center justify-between mb-6">
                  <div className="flex items-center gap-3">
                    <Skeleton
                      animation="wave"
                      variant="circular"
                      width={50}
                      height={50}
                    />

                    <div>
                      <Skeleton
                        animation="wave"
                        variant="text"
                        width={180}
                        height={30}
                      />
                      <Skeleton
                        animation="wave"
                        variant="text"
                        width={120}
                        height={20}
                      />
                    </div>
                  </div>

                  <Skeleton
                    animation="wave"
                    variant="rounded"
                    width={100}
                    height={40}
                  />
                </div>

                {/* Main Content */}
                <div className="grid grid-cols-2 gap-5 mb-6">
                  <Skeleton animation="wave" variant="rounded" height={220} />
                  <Skeleton animation="wave" variant="rounded" height={220} />
                </div>

                {/* Text Lines */}
                <div className="space-y-3 mb-6">
                  <Skeleton animation="wave" variant="text" height={25} />
                  <Skeleton
                    animation="wave"
                    variant="text"
                    height={25}
                    width="90%"
                  />
                  <Skeleton
                    animation="wave"
                    variant="text"
                    height={25}
                    width="75%"
                  />
                </div>

                {/* Bottom Buttons */}
                <div className="flex justify-end gap-4 mt-10">
                  <Skeleton
                    animation="wave"
                    variant="rounded"
                    width={120}
                    height={42}
                  />
                  <Skeleton
                    animation="wave"
                    variant="rounded"
                    width={120}
                    height={42}
                  />
                </div>
              </div>
            ) : (
              <div
                key={recce?.storeName + Math.random()}
                className={`shadow-xl bg-gray-100 flex flex-col ${selectedRing}`}
                style={isPreview ? { border: "1px solid black" } : {}}
              >
                <div className="flex justify-end items-center p-3 sm:p-4 flex-wrap gap-2">
                  {recce?.job?.adaptationImage && (
                    <>
                      {/* STATUS — ADMIN + CLIENT dono ke liye */}

                      {(role == "admin" || role == "client") && (
                        <div className="font-semibold flex justify-center items-center text-xs sm:text-sm mx-2 sm:mx-4">
                          Status:
                          <span
                            className={`
            ml-2 px-3 py-1 rounded-full text-white
            ${
              currentStatus === "Approved"
                ? "bg-green-400"
                : currentStatus === "Rejected"
                  ? "bg-red-400"
                  : "bg-yellow-400"
            }
          `}
                          >
                            {currentStatus}
                          </span>
                        </div>
                      )}

                      {/* APPROVE / REJECT — ONLY CLIENT */}

                      {role === "client" && (
                        <div className="flex items-center gap-2 mr-2 sm:mr-3">
                          {/* Approve Button */}
                          <button
                            onClick={() => handleApprove(jobId)}
                            disabled={
                              currentStatus !== "Pending" || approvedLoading
                            }
                            className={`
        min-w-[90px]
        h-[35px]
        flex items-center justify-center
        rounded-lg
        bg-green-400
        text-white
        font-medium
        shadow-md
        transition-all duration-200
        hover:bg-green-500 hover:shadow-lg
        active:scale-95
        disabled:bg-gray-300
        disabled:cursor-not-allowed
      `}
                          >
                            {approvedLoading ? (
                              <div className="flex items-center gap-2">
                                <CircularProgress
                                  size={18}
                                  sx={{ color: "white" }}
                                />
                                <span>Approving...</span>
                              </div>
                            ) : (
                              "Approve"
                            )}
                          </button>

                          {/* Reject Button */}
                          <button
                            onClick={() => handleReject(jobId)}
                            disabled={
                              currentStatus !== "Pending" || rejectLoading
                            }
                            className={`
        min-w-[90px]
        h-[35px]
        flex items-center justify-center
        rounded-lg
        bg-red-400
        text-white
        font-medium
        shadow-md
        transition-all duration-200
        hover:bg-red-500 hover:shadow-lg
        active:scale-95
        disabled:bg-gray-300
        disabled:cursor-not-allowed
      `}
                          >
                            {rejectLoading ? (
                              <div className="flex items-center gap-2">
                                <CircularProgress
                                  size={18}
                                  sx={{ color: "white" }}
                                />
                                <span>Rejecting...</span>
                              </div>
                            ) : (
                              "Reject"
                            )}
                          </button>
                        </div>
                      )}
                    </>
                  )}
                  <img
                    src="/assests/images/pixell dark.png"
                    alt="Pixell Logo"
                    className="w-24 h-auto"
                  />
                </div>

                <div className="flex flex-col lg:flex-row gap-3 lg:gap-6 px-3 lg:px-6 pb-4 sm:pb-6 min-w-0">
                  <div className="w-full lg:w-[65%] flex flex-col gap-3 sm:gap-4 min-w-0">
                    <div className="bg-white rounded-xl shadow-md p-4 border">
                      <div className="flex items-center mb-2 ml-4 mt-4">
                        <h2 className="text-lg font-semibold ">
                          Product Name:{" "}
                        </h2>
                        <h2 className="text-lg ml-2">
                          {recce?.product?.productType || "N/A"}
                        </h2>
                      </div>
                      <div className="flex h-[14rem]">
                        <div className="bg-white w-[50%] h-[13rem] flex flex-col   p-2 ">
                          <div>
                            {recce?.job?.imageOfRecceSpace ? (
                              <div className="w-full h-[180px] flex justify-start">
                                <img
                                  src={recce?.job?.imageOfRecceSpace}
                                  alt="Recce Image"
                                  className="h-full w-auto object-contain ml-[10px]"
                                />
                              </div>
                            ) : (
                              <div className="w-full h-[180px] flex items-center justify-center text-gray-500">
                                Recce photo not available
                              </div>
                            )}
                          </div>
                          <p className="text-center mt-1"> Recce Image </p>
                        </div>
                        <div className="bg-white w-[50%]  h-[13rem] flex flex-col   p-2 ">
                          <div>
                            {recce?.job?.clientSideAdaptationImage ? (
                              <div className="w-full h-[180px] flex justify-start">
                                <img
                                  src={recce?.job?.clientSideAdaptationImage}
                                  alt="Reference Creative Image"
                                  className="h-full w-auto object-contain ml-[10px]"
                                />
                              </div>
                            ) : (
                              <div className="w-full h-[180px] flex items-center justify-center text-gray-500">
                                Reference creative not available
                              </div>
                            )}
                          </div>
                          <p className="text-center mt-1">
                            {" "}
                            Reference Creative{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="bg-white rounded-xl shadow-md p-3 sm:p-4 border">
                      <div className="flex justify-between items-center">
                        <h2 className="text-lg font-semibold mb-3">
                          Creative Adaptation
                        </h2>
                        {/* {role === "admin" && (
                          <button
                            onClick={() => {
                              if (recce?.clientStatus == 1) {
                                handleCreativeOpen(recce);
                              }
                            }}
                            className="px-3 py-1 bg-blue-500 text-white rounded"
                          >
                            {recce?.job?.adaptationImage ? "Update" : "Upload"}
                          </button>
                        )} */}
                        {role === "admin" && (
                          <Tooltip
                            title={
                              recce?.clientStatus === 1
                                ? "Upload / Update Creative"
                                : "Creative can only be uploaded after client approval"
                            }
                          >
                            <span>
                              <button
                                onClick={() => {
                                  if (recce?.clientStatus === 1) {
                                    handleCreativeOpen(recce);
                                  }
                                }}
                                disabled={recce?.clientStatus !== 1}
                                className={`px-3 py-1 rounded text-white ${
                                  recce?.clientStatus === 1
                                    ? "bg-blue-500 hover:bg-blue-600 cursor-pointer"
                                    : "bg-gray-400 cursor-not-allowed"
                                }`}
                              >
                                {recce?.job?.adaptationImage
                                  ? "Update"
                                  : "Upload"}
                              </button>
                            </span>
                          </Tooltip>
                        )}
                      </div>

                      <div>
                        {recce?.job?.adaptationImage ? (
                          <div className="w-full h-[18vh] relative">
                            <img
                              src={recce?.job?.adaptationImage}
                              alt="Creative Adaptation"
                              className="h-full w-full object-contain object-left cursor-crosshair"
                              onClick={(e) => {
                                e.stopPropagation();
                                if (role !== "client") return;
                                handleImageClick(e, jobId);
                              }}
                            />
                            {/* COMMENT DOTS */}

                            {comments?.map((c, i) => {
                              const userName = c.commentedBy?.name || "User";
                              const initial = userName.charAt(0).toUpperCase();

                              const timeAgo = c.updatedAt
                                ? new Date(c.updatedAt).toLocaleDateString()
                                : "";

                              return (
                                <div
                                  key={i}
                                  className="absolute group"
                                  style={{
                                    left: `${c.coordinates.x}%`,
                                    top: `${c.coordinates.y}%`,
                                    transform: "translate(-50%, -50%)",
                                  }}
                                >
                                  {/* DOT */}
                                  <div
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setActiveCommentBox({
                                        jobId,
                                        x: c.coordinates.x,
                                        y: c.coordinates.y,
                                        text: c.text,
                                      });
                                      setSelectedCommentIndex(
                                        role === "client" ? i : null,
                                      );
                                    }}
                                    className="w-7 h-7 rounded-full bg-purple-600 text-white flex items-center justify-center shadow-lg cursor-pointer border-2 border-white hover:scale-110 transition"
                                  >
                                    {i + 1}
                                  </div>

                                  {/* TOOLTIP */}
                                  <div className="absolute left-32 -translate-x-1/2 -top-16 hidden group-hover:flex z-50">
                                    <div className="flex items-center gap-3 bg-gray-900 text-white px-4 py-2 rounded-xl shadow-xl min-w-[180px]">
                                      {/* Avatar */}
                                      <div className="w-8 h-8 rounded-full bg-purple-600 flex items-center justify-center text-sm font-semibold">
                                        {i + 1}
                                      </div>

                                      {/* Text */}
                                      <div className="flex flex-col">
                                        <span className="text-xs text-gray-300">
                                          {userName} · {timeAgo}
                                        </span>
                                        <span className="text-sm font-medium">
                                          {c.text}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            })}

                            {/* COMMENT INPUT */}

                            {activeCommentBox &&
                              activeCommentBox.jobId === jobId && (
                                <div
                                  className="
      absolute
      bg-white
      border
      shadow-lg
      rounded
      p-2 sm:p-3 z-50
    "
                                  style={{
                                    left: `${activeCommentBox.x}%`,
                                    top: `${activeCommentBox.y}%`,
                                    // width: "min(256px, 70vw)",
                                  }}
                                >
                                  <textarea
                                    rows={3}
                                    placeholder="Write comment..."
                                    readOnly={role !== "client"}
                                    className={`w-full border p-2 rounded ${
                                      role !== "client"
                                        ? "bg-gray-100 cursor-not-allowed"
                                        : ""
                                    }`}
                                    value={activeCommentBox.text}
                                    onChange={(e) =>
                                      setActiveCommentBox({
                                        ...activeCommentBox,
                                        text: e.target.value,
                                      })
                                    }
                                  />

                                  <div className="flex justify-between gap-2 mt-2">
                                    {/* DELETE */}

                                    {role === "client" &&
                                      selectedCommentIndex !== null && (
                                        <button
                                          onClick={deleteComment}
                                          className="px-3 py-1 bg-red-500 text-white rounded"
                                        >
                                          Delete
                                        </button>
                                      )}
                                    <div className="flex gap-2 ml-auto">
                                      <button
                                        onClick={() => {
                                          setActiveCommentBox(null);
                                          setSelectedCommentIndex(null);
                                        }}
                                        className="px-3 py-1 bg-gray-200 rounded"
                                      >
                                        Cancel
                                      </button>
                                      {role === "client" && (
                                        <button
                                          onClick={() => saveComment(jobId)}
                                          className="px-3 py-1 bg-blue-500 text-white rounded"
                                        >
                                          {selectedCommentIndex !== null
                                            ? "Update"
                                            : "Save"}
                                        </button>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              )}
                          </div>
                        ) : (
                          <div className="w-full flex items-center h-[15vh] justify-center text-gray-500">
                            Adaptation not available
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="w-full lg:w-[35%] flex flex-col gap-3 sm:gap-4 min-w-0">
                    <div className="bg-white rounded-xl shadow-md p-4 border">
                      <h3 className="font-semibold text-gray-800 mb-3">
                        Store Details
                      </h3>
                      <div className="space-y-2 text-sm text-gray-700">
                        <p> Store : {recce?.job?.storeName || "N/A"}</p>
                        <p>Name : {recce?.job?.storeOwnerName || "N/A"}</p>
                        <p>
                          Phone : {recce?.job?.storeOwnerPhoneNumber || "N/A"}
                        </p>
                        <p className="flex items-start gap-2">
                          Address : {recce?.job?.address || "N/A"}
                        </p>
                      </div>
                    </div>

                    <div className="bg-white rounded-xl shadow-md p-4 border">
                      <h3 className="font-semibold text-gray-800 mb-3">
                        Measurement Details
                      </h3>
                      <div className="space-y-2 text-sm text-gray-700">
                        <p>
                          Dimensions (W x H):{" "}
                          {availableWidth && availableHeight
                            ? `${Math.round(availableWidth * 12)}" × ${Math.round(availableHeight * 12)}"`
                            : "N/A"}
                        </p>

                        <p>
                          Area:{" "}
                          {availableWidth && availableHeight
                            ? `${Math.ceil(availableWidth * availableHeight).toFixed(2)} sq.ft.`
                            : "N/A"}
                        </p>

                        <p className="font-semibold text-gray-700 ">
                          Approved Dimensions (W x H):{" "}
                          {approvedWidth && approvedHeight
                            ? `${Math.round(approvedWidth * 12)}" × ${Math.round(approvedHeight * 12)}"`
                            : "N/A"}
                        </p>

                        <p className="font-semibold text-gray-700 ">
                          Approved Area:{" "}
                          {approvedWidth && approvedHeight
                            ? `${Math.ceil(approvedWidth * approvedHeight).toFixed(2)} sq.ft.`
                            : "N/A"}
                        </p>
                      </div>
                    </div>

                    <div className="bg-white rounded-xl shadow-md p-4 border">
                      <h3 className="font-semibold text-gray-800 mb-3">
                        Additional Details
                      </h3>
                      <div className="space-y-2 text-sm text-gray-700">
                        <p>
                          Mounting Base Type :{" "}
                          {recce?.job?.typeOfMountingBase || "N/A"}
                        </p>
                        <p>
                          External Equipments :{" "}
                          {recce?.job?.externalEquipments?.length
                            ? recce?.job?.externalEquipments.join(", ")
                            : "N/A"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="w-full h-4 bg-gradient-to-r from-pink-200 via-purple-200 to-blue-300"></div>
              </div>
            )}
          </>
        );

      case "completion-ppt":
        return (
          <div
            key={recce?.storeName + Math.random()}
            className={`shadow-xl bg-gray-100 flex flex-col ${selectedRing}`}
            style={isPreview ? { border: "1px solid black" } : {}}
          >
            <div className="flex justify-end p-4">
              {role == "admin" && (
                <div className="mx-4">
                  {!clientId && [-1, 1, 0, 4].includes(Number(userRole)) && (
                    <InstallationFlag
                      data={recce}
                      flagStatus={
                        flagStatuses[recce?.productId] ||
                        recce?.product?.installationFlag?.status
                      }
                      onFlagSuccess={(status) => {
                        setFlagStatuses((prev) => ({
                          ...prev,
                          [recce?.productId]: status,
                        }));
                        getApprovalList();
                      }}
                      onFlagResolve={(status) => {
                        setFlagStatuses((prev) => ({
                          ...prev,
                          [recce?.productId]: status,
                        }));
                        getApprovalList();
                      }}
                    />
                  )}
                </div>
              )}
              <img
                src="/assests/images/pixell dark.png"
                alt="Pixell Logo"
                className="w-24 h-auto"
              />
            </div>

            <div className="flex flex-col lg:flex-row gap-4 lg:gap-6 px-4 lg:px-6 pb-6">
              <div className="w-full lg:w-[65%] flex flex-col gap-2">
                <div className="bg-white  rounded-xl border border-1  w-full">
                  <div className="flex items-center mb-2 ml-4 mt-4">
                    <h2 className="text-lg font-semibold ">Product Name: </h2>
                    <h2 className="text-lg ml-2">
                      {recce?.product?.productType || "N/A"}
                    </h2>
                  </div>
                  <div className="flex h-[14rem]">
                    <div className="bg-white w-[50%] h-[13rem] flex flex-col   p-2 ">
                      <div>
                        {recce?.job?.imageOfRecceSpace ? (
                          <div className="w-full h-[180px] flex justify-start">
                            <img
                              src={recce?.job?.imageOfRecceSpace}
                              alt="Recce Image"
                              className="h-full w-auto object-contain ml-[10px]"
                            />
                          </div>
                        ) : (
                          <div className="w-full h-[180px] flex items-center justify-center text-gray-500">
                            Recce photo not available
                          </div>
                        )}
                      </div>
                      <p className="text-center mt-1"> Recce Image </p>
                    </div>
                    <div className="bg-white w-[50%]  h-[13rem] flex flex-col   p-2 ">
                      <div>
                        {recce?.installationJob?.imagesOfInstallation
                          ?.frontPhoto ? (
                          <div className="w-full h-[180px] flex justify-start">
                            <img
                              src={
                                geoTag === "with"
                                  ? recce?.installationJob?.imagesOfInstallation
                                      ?.frontPhoto
                                  : recce?.installationJob?.imagesOfInstallation
                                      ?.leftPhoto ||
                                    recce?.installationJob?.imagesOfInstallation
                                      ?.frontPhoto
                              }
                              alt="Recce Image"
                              className="h-full w-auto object-contain ml-[10px]"
                            />
                          </div>
                        ) : (
                          <div className="w-full h-[180px] flex items-center justify-center text-gray-500">
                            Installation photo not available
                          </div>
                        )}
                      </div>
                      <p className="text-center mt-1"> Installation Image </p>
                    </div>
                  </div>
                </div>

                <div className="bg-white rounded-xl shadow-md p-4 border">
                  <h2 className="text-lg font-semibold mb-3">
                    Creative Adaptation
                  </h2>

                  <div>
                    {recce?.job?.adaptationImage ? (
                      <div className="w-full h-[18vh]">
                        <img
                          src={recce?.job?.adaptationImage}
                          alt="Creative Adaptation"
                          className="h-full w-auto object-contain"
                        />
                      </div>
                    ) : (
                      <div className="w-full h-[17vh] flex items-center justify-center text-gray-500">
                        Adaptation not available
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className="w-full lg:w-[35%] flex flex-col gap-4">
                <div className="bg-white rounded-xl shadow-md p-4 border">
                  <h3 className="font-semibold text-gray-800 mb-3">
                    Store Details
                  </h3>
                  <div className="space-y-2 text-sm text-gray-700">
                    <p> Store : {recce?.job?.storeName || "N/A"}</p>
                    <p>Name : {recce?.job?.storeOwnerName || "N/A"}</p>
                    <p>Phone : {recce?.job?.storeOwnerPhoneNumber || "N/A"}</p>
                    <p className="flex items-start gap-2">
                      Address : {recce?.job?.address || "N/A"}
                    </p>
                  </div>
                </div>

                <div className="bg-white rounded-xl shadow-md p-4 border">
                  <h3 className="font-semibold text-gray-800 mb-3">
                    Measurement Details
                  </h3>
                  <div className="space-y-2 text-sm text-gray-700">
                    <p>
                      Dimensions (W x H):{" "}
                      {availableWidth && availableHeight
                        ? `${Math.round(availableWidth * 12)}" × ${Math.round(availableHeight * 12)}"`
                        : "N/A"}
                    </p>

                    <p>
                      Area:{" "}
                      {availableWidth && availableHeight
                        ? `${Math.ceil(availableWidth * availableHeight).toFixed(2)} sq.ft.`
                        : "N/A"}
                    </p>

                    <p className="font-semibold text-gray-700 ">
                      Approved Dimensions (W x H):{" "}
                      {approvedWidth && approvedHeight
                        ? `${Math.round(approvedWidth * 12)}" × ${Math.round(approvedHeight * 12)}"`
                        : "N/A"}
                    </p>

                    <p className="font-semibold text-gray-700 ">
                      Approved Area:{" "}
                      {approvedWidth && approvedHeight
                        ? `${Math.ceil(approvedWidth * approvedHeight).toFixed(2)} sq.ft.`
                        : "N/A"}
                    </p>
                  </div>
                </div>

                <div className="bg-white rounded-xl shadow-md p-4 border">
                  <h3 className="font-semibold text-gray-800 mb-3">
                    Additional Details
                  </h3>
                  <div className="space-y-2 text-sm text-gray-700">
                    <p>
                      Mounting Base Type :{" "}
                      {recce?.job?.typeOfMountingBase || "N/A"}
                    </p>
                    <p>
                      External Equipments :{" "}
                      {recce?.job?.externalEquipments?.length
                        ? recce.job.externalEquipments.join(", ")
                        : "N/A"}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="w-full h-4 bg-gradient-to-r from-pink-200 via-purple-200 to-blue-300"></div>
          </div>
        );

      default:
        return null;
    }
  };
  const nextSlide = () => {
    if (currentIndex < previewRecceData.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const prevSlide = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === "ArrowRight") {
        nextSlide();
      }

      if (e.key === "ArrowLeft") {
        prevSlide();
      }
    };

    window.addEventListener("keydown", handleKey);

    return () => {
      window.removeEventListener("keydown", handleKey);
    };
  }, [currentIndex, previewRecceData]);

  const renderPreview = () => {
    // Check if there's any data to show
    if (!previewRecceData || previewRecceData.length === 0) {
      const isCompletionInstalledOnly =
        selectedTemplate?.layoutType === "completion-ppt" &&
        completionDownloadScope === "installedOnly";

      return (
        <div className="flex flex-1 items-center justify-center h-[75vh]">
          <div className="text-center">
            <div className="text-6xl mb-4">📄</div>
            <h2 className="text-xl font-semibold text-gray-700">
              {isCompletionInstalledOnly
                ? "No Installation Photos Available"
                : "No Approved Data Available"}
            </h2>
            <p className="text-gray-500 mt-2">
              {isCompletionInstalledOnly
                ? "None of the stores currently have an installation image. Try 'All Slides' instead."
                : "There are no approved recce jobs to display in the PPT."}
            </p>
          </div>
        </div>
      );
    }

    if (!selectedTemplate) {
      return (
        <div className="flex flex-1 items-center justify-center h-[75vh]">
          <div className="text-center">
            <div className="text-6xl mb-4">📄</div>
            <h2 className="text-xl font-semibold text-gray-700">
              Please select a template
            </h2>

            <p className="text-gray-500 mt-2">
              Select a template above to preview the report
            </p>
          </div>
        </div>
      );
    }
    const currentRecce = previewRecceData[currentIndex];

    return (
      <div className="mt-6">
        <div className="relative flex items-center justify-center">
          <button
            onClick={prevSlide}
            disabled={currentIndex === 0}
            className={`
            absolute left-2
            z-10
            bg-white
            shadow-lg
            rounded-full
          
            flex
            items-center
            justify-center
            w-9 h-9 sm:w-10 sm:h-10 lg:w-12 lg:h-12
text-base sm:text-lg lg:text-xl
            ${
              currentIndex === 0
                ? "opacity-40 cursor-not-allowed"
                : "hover:bg-gray-100"
            }
          `}
          >
            ←
          </button>
          <div
            className="
            w-full
            flex
            justify-center
            items-center
          "
          >
            <div
              className="
              ppt-slide
              bg-white
              rounded-lg
              shadow-xl
              transition-all
              duration-300
              mx-auto
               w-full
    max-w-[1400px]
            "
            >
              {renderTemplateCard(
                currentRecce,
                {
                  layoutType: selectedTemplate?.layoutType,
                  bgColor: selectedTemplate?.bgColor,
                },
                true,
              )}
            </div>
          </div>

          <button
            onClick={nextSlide}
            disabled={currentIndex === previewRecceData.length - 1}
            className={`
            absolute right-2
            z-10
            bg-white
            shadow-lg
            rounded-full
            
            flex
            items-center
            justify-center
           w-9 h-9 sm:w-10 sm:h-10 lg:w-12 lg:h-12
text-base sm:text-lg lg:text-xl
            ${
              currentIndex === previewRecceData.length - 1
                ? "opacity-40 cursor-not-allowed"
                : "hover:bg-gray-100"
            }
          `}
          >
            →
          </button>
        </div>
        <div className="text-center mt-4 text-gray-500 text-sm">
          Slide {currentIndex + 1} of {previewRecceData.length}
        </div>
      </div>
    );
  };

  if (!isOpen) return null;
  return (
    <>
      <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50 p-4">
        <div
          ref={modalRef}
          className="
  bg-white
  w-full
  max-w-[98vw]
  sm:max-w-[95vw]
  lg:max-w-8xl
  rounded-lg
  shadow-lg
  overflow-hidden
  h-[98vh]
  sm:h-[95vh]
  md:h-[92vh]
  lg:h-[98vh]
  p-2 sm:p-4 md:p-6
  flex
  flex-col
  relative
"
        >
          <div className="flex justify-between items-center mb-2 sm:mb-4 flex-wrap gap-2">
            <div className="flex">
              {templates.map((tpl) => (
                <div key={tpl?.id} className="flex-shrink-0">
                  {renderTemplateThumbnail(tpl)}
                </div>
              ))}
            </div>
            <div className="flex flex-wrap items-center gap-2">
              {selectedTemplate?.layoutType === "completion-ppt" && (
                <div className="flex items-center gap-3 text-xs sm:text-sm bg-gray-50 border rounded-lg px-3 py-1.5 mx-1 sm:mx-2">
                  <label className="flex items-center gap-1 cursor-pointer">
                    <input
                      type="radio"
                      name="completionDownloadScope"
                      checked={completionDownloadScope === "all"}
                      disabled={isLoading || Boolean(downloadInfo)}
                      onChange={() => setCompletionDownloadScope("all")}
                    />
                    All Slides
                  </label>
                  <label className="flex items-center gap-1 cursor-pointer">
                    <input
                      type="radio"
                      name="completionDownloadScope"
                      checked={completionDownloadScope === "installedOnly"}
                      disabled={isLoading || Boolean(downloadInfo)}
                      onChange={() =>
                        setCompletionDownloadScope("installedOnly")
                      }
                    />
                    Installation Photo Only
                  </label>
                </div>
              )}
              <div className="flex flex-wrap gap-2">
                {downloadInfo ? (
                  // Step 2: file is ready — this is a real <a href> download link,
                  // not a JS-triggered click. Browser handles the actual save.
                  <a
                    href={downloadInfo.url}
                    download={downloadInfo.fileName}
                    className="px-2 sm:px-4 py-2 gap-1 sm:gap-2 mx-1 sm:mx-4 text-white rounded bg-green-600 hover:bg-green-700 flex items-center justify-center"
                  >
                    <CloudDownloadIcon fontSize="small" />
                    <span className="hidden sm:inline ml-1">Download PPT</span>
                    <span className="sm:hidden ml-1">PPT</span>
                  </a>
                ) : (
                  // Step 1: process/generate the PPT first
                  <button
                    onClick={() => handleDownload()}
                    disabled={
                      isLoading ||
                      !mergedRecceData ||
                      mergedRecceData.length === 0
                    }
                    className={`px-2 sm:px-4 py-2 gap-1 sm:gap-2 mx-1 sm:mx-4 text-white rounded ${
                      isLoading ||
                      !mergedRecceData ||
                      mergedRecceData.length === 0
                        ? "bg-gray-400 cursor-not-allowed"
                        : "bg-blue-500 hover:bg-blue-700"
                    }`}
                  >
                    {isLoading ? (
                      `${progress}%`
                    ) : (
                      <>
                        <span className="hidden sm:inline">Generate PPT</span>
                        <span className="sm:hidden">PPT</span>
                      </>
                    )}
                  </button>
                )}
                <button
                  onClick={onClose}
                  className="text-gray-600 hover:text-black text-xl"
                >
                  ✕
                </button>
              </div>
            </div>
          </div>

          <div className="flex-1 overflow-auto">{renderPreview()}</div>
        </div>
      </div>

      {/* Approval Comment Modal */}
      <ClientRecceApprovalModal
        open={approvalModalOpen}
        onClose={() => {
          if (!recceApproveLoadingId) {
            setApprovalModalOpen(false);
            setPendingRecceData(null);
          }
        }}
        onSubmit={handleApprovalSubmit}
        isLoading={recceApproveLoadingId}
      />

      {/* Rejection Comment Modal */}
      <ClientRecceRejectedModal
        open={rejectModalOpen}
        onClose={() => {
          if (!recceRejectLoadingId) {
            setRejectModalOpen(false);
            setPendingRecceData(null);
          }
        }}
        onSubmit={handleRejectSubmit}
        isLoading={recceRejectLoadingId}
      />

      {/* Snackbar - Only for client approval/rejection notifications */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
}
